import { render, staticRenderFns } from "./ScheduledTournamentCalendar.vue?vue&type=template&id=3ca621d4&"
import script from "./ScheduledTournamentCalendar.vue?vue&type=script&lang=js&"
export * from "./ScheduledTournamentCalendar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports